import type { StateCreator } from 'zustand';
import type { FlowMedia } from '@/types';

import type { ResultSlice } from './types';

export type { ResultSlice } from './types';

export const resultInitialState = {
  resultFile: null as FlowMedia | null,
  generationTimestamp: null as number | null,
  localNotification: null as FlowMedia | null,
};

export const createResultSlice: StateCreator<
  ResultSlice,
  [],
  [],
  ResultSlice
> = (set) => ({
  ...resultInitialState,

  setResultFile: (resultFile) => set({ resultFile }),
  setGenerationTimestamp: (generationTimestamp) => set({ generationTimestamp }),
  setLocalNotification: (localNotification) => set({ localNotification }),
});
